import React from "react";

// "Juan Perez • TR120": the firm's case number rides along with the client
// name wherever the name is listed. The number sits in its own element so it
// keeps the exact casing the firm typed, even inside capitalized cells.

export const clientName = (item = {}) =>
  [item.clientFirstName, item.clientLastName].filter(Boolean).join(" ");

export const hasClientOrCase = (item = {}) =>
  Boolean(item.clientFirstName || item.caseNumber);

export const clientLabel = (item = {}) =>
  [clientName(item), item.caseNumber].filter(Boolean).join(" • ");

// `inlineCase={false}` leaves the number out when there is a name, for cells
// that show it on its own line with CaseNumberLine instead.
const ClientWithCase = ({ item = {}, inlineCase = true }) => {
  const name = clientName(item);
  const showCase = item.caseNumber && (inlineCase || !name);
  return (
    <>
      {name}
      {showCase && (
        <span className="clientCaseNumber">
          {name ? " • " : ""}
          {item.caseNumber}
        </span>
      )}
    </>
  );
};

// Narrow list cells (120px) would cut "Juan Perez • TR120" to "Juan Perez • T…",
// so there the number goes on a second line under the name.
export const CaseNumberLine = ({ item = {}, className = "" }) =>
  clientName(item) && item.caseNumber ? (
    <p className={`${className} clientCaseNumber clientCaseNumberLine`}>
      {item.caseNumber}
    </p>
  ) : null;

export default ClientWithCase;
